export default [
    // 计费管理
    // 计费管理收费
    {
        path: "accountmanage/sortmanage/list",
        name: "billSortmanage",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/sortmanage/index"),
    },
    // 客户费率设置
    // 费率模板
    {
        path: "accountmanage/customerrate/billtemplate/list",
        name: "customerRateTemplatelist",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/customerrate/billtemplate/index"),
    },
    {
        path: "accountmanage/customerrate/billtemplate/:type",
        name: "customerRateTemplateupdate",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/customerrate/billtemplate/update"),
    },
    // 客户费率
    {
        path: "accountmanage/customerrate/customerbill/list",
        name: "customerRateBilllist",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/customerrate/customerbill/index"),
    },
    {
        path: "accountmanage/customerrate/customerbill/:type",
        name: "customerRateBillupdate",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/customerrate/customerbill/update"),
    },
    // 计费单
    {
        path: "accountmanage/billorder/list",
        name: "billorderlist",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/billorder/index"),
    },
    {
        path: "accountmanage/billorder/:type",
        name: "billorderupdate",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/billorder/update"),
    },
    // 费用明细-》仓库作业费
    {
        path: "accountmanage/costdetail/warelist",
        name: "wareList",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/costdetail/wareindex"),
    },
    // 费用明细-》仓储费
    {
        path: "accountmanage/costdetail/warecostlist",
        name: "warecostList",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/costdetail/warecostindex"),
    },
    // 费用明细- 增值服务费明细
    {
        path: "accountmanage/costdetail/service",
        name: "serviceCostList",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/costdetail/service"),
    },
    // 费用明细-   包材费明细
    {
        path: "accountmanage/costdetail/material",
        name: "materialCostList",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/costdetail/material"),
    },
    // 费用黑名单
    {
        path: "accountmanage/feeblacklist",
        name: "feeBlackList",
        component: () => import(/* webpackChunkName: "accountmanage" */ "@/views/accountmanage/feeblacklist/index"),
    },
]
